const _ = require('lodash')
const axios = require('axios')

const messages = {
  en: {},
  cs: {},
  sk: {},
  de: {}
}


const fetchTranslations = async (group) => {
  const result = await axios.get(`/translations/${group}`)

  _.forEach(_.keys(messages), lang => {
    const keyed = _.keyBy(result.data, 'name')
    const messages = _.mapValues(keyed, lang)
    i18n.setLocaleMessage(lang, messages)
  })
}


export {
  messages,
  fetchTranslations
}
